import { apiGet, apiPatch, apiPost } from '../client';
import {
  ExpenseResponseSchema,
  ExpensesResponseSchema,
  type ExpenseCategory,
  type ExpenseRecord,
  type ExpensesResponse,
} from '../schemas';

/** Owner-only ledger of Gastos (docs/CONCEPTS.md: Gasto). */
export function listExpenses(): Promise<ExpensesResponse> {
  return apiGet('/v1/business/expenses', ExpensesResponseSchema);
}

export type CreateExpenseInput = {
  concept: string;
  amountCents: number;
  category: ExpenseCategory;
  incurredOn: string;
  isRecurringMonthly?: boolean;
  recurringUntil?: string;
};

export async function createExpense(
  input: CreateExpenseInput,
  idempotencyKey: string,
): Promise<ExpenseRecord> {
  const response = await apiPost('/v1/business/expenses', ExpenseResponseSchema, input, idempotencyKey);
  return response.data;
}

export type PatchExpenseInput = Partial<{
  concept: string;
  amountCents: number;
  category: ExpenseCategory;
  incurredOn: string;
  isRecurringMonthly: boolean;
  recurringUntil: string | null;
  isActive: boolean;
}>;

export async function patchExpense(
  expenseId: string,
  input: PatchExpenseInput,
  idempotencyKey: string,
): Promise<ExpenseRecord> {
  const response = await apiPatch(
    `/v1/business/expenses/${encodeURIComponent(expenseId)}`,
    ExpenseResponseSchema,
    input,
    idempotencyKey,
  );
  return response.data;
}
